/**
 * Central gate for all Demo / Sales / Launch UI.
 *
 * Demo UI (AI Presentation, Guided Tour, demo banner, first-login presentation
 * selector, demo/launch reset tools, demo logins) must NEVER appear on the live
 * production domain — even if a build accidentally baked REACT_APP_DEMO_MODE=true
 * (preview and production currently share one build-time .env).
 *
 * Rule: a demo feature is enabled ONLY when its flag is explicitly "true" AND we
 * are running on a preview/local host. The production custom domain is therefore
 * always clean, regardless of the baked flag value.
 */
const flag = (v) => (v || "").trim().toLowerCase() === "true";

export const isDemoCapableHost = () => {
  if (typeof window === "undefined" || !window.location) return false;
  const h = (window.location.hostname || "").toLowerCase();
  return (
    h.includes("preview.emergentagent.com") ||
    h === "localhost" ||
    h.startsWith("127.") ||
    h.endsWith(".local")
  );
};

const demoHost = isDemoCapableHost();

export const SHOW_DEMO_TOOLS = flag(process.env.REACT_APP_DEMO_MODE) && demoHost;
export const SHOW_LAUNCH_TOOLS = flag(process.env.REACT_APP_SHOW_LAUNCH_TOOLS) && demoHost;
export const SHOW_DEMO_LOGINS = flag(process.env.REACT_APP_SHOW_DEMO_LOGINS) && demoHost;
